if (!customElements.get('ps-reformer-accessories')) {
  customElements.define('ps-reformer-accessories', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('.ps-accessories__track');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      if (!this.track) return;
      this.querySelector('.ps-accessories__arrows').hidden = false;
      const updateArrows = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      };
      const scroll = (direction) => this.track.scrollBy({
        left: direction * (this.track.clientWidth + parseFloat(getComputedStyle(this.track).gap)),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      this.previous.addEventListener('click', () => scroll(-1), { signal });
      this.next.addEventListener('click', () => scroll(1), { signal });
      this.track.addEventListener('scroll', updateArrows, { passive:true, signal });
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(updateArrows);
      this.resizeObserver.observe(this.track);
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-variant-select]')) this.updateVariant(event.target);
      }, { signal });
      this.addEventListener('submit', (event) => {
        if (!event.target.matches('.ps-accessories__form')) return;
        const helper = window.Alpine?.store('xCartHelper');
        if (!helper) return; // Native Shopify product form remains a working fallback.
        event.preventDefault();
        this.addToCart(event.target, helper);
      }, { signal });
      updateArrows();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
    updateVariant(select) {
      const option = select.selectedOptions[0];
      const card = select.closest('[data-card]');
      card.querySelector('.ps-accessories__price').textContent = option.dataset.price;
      card.querySelectorAll('[data-product-link]').forEach(link => link.href = option.dataset.url);
      const image = card.querySelector('.ps-accessories__media img');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
      const available = option.dataset.available === 'true';
      card.querySelector('button[type="submit"]').disabled = !available;
      card.querySelector('[data-button-label]').textContent = available ? this.dataset.addLabel : this.dataset.soldoutLabel;
      card.querySelector('[data-status]').textContent = '';
    }
    async addToCart(form, helper) {
      if (form.dataset.busy === 'true') return;
      const button = form.querySelector('button[type="submit"]');
      if (button.disabled) return;
      const label = form.querySelector('[data-button-label]');
      const status = form.querySelector('[data-status]');
      const select = form.querySelector('select');
      const originalLabel = label.textContent;
      const payload = new FormData(form);
      form.dataset.busy = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (select) select.disabled = true;
      label.textContent = this.dataset.loadingLabel;
      status.textContent = '';
      let locked = false;
      let added = false;
      const root = window.Shopify?.routes?.root || '/';
      try {
        await helper.waitForCartUpdate();
        window.updatingCart = true;
        locked = true;
        payload.set('sections', helper.getSectionsToRender().map(section => section.id).join(','));
        payload.set('sections_url', window.location.pathname);
        const response = await fetch(`${root}cart/add.js`, { method:'POST', headers:{ Accept:'application/json' }, body:payload });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.errorLabel);
        added = true;
        status.textContent = this.dataset.addedLabel;
        if (!result.sections?.['cart-drawer']) {
          window.location.assign(`${root}cart`);
          return;
        }
        await helper.reRenderSections(result.sections);
        const count = parseInt(document.querySelector('#cart-icon-bubble span')?.textContent, 10);
        if (Number.isFinite(count)) helper.currentItemCount = count;
        document.dispatchEvent(new CustomEvent('pilates:cart:items-changed'));
        const miniCart = window.Alpine?.store('xMiniCart');
        if (miniCart) miniCart.openCart();
        else window.location.assign(`${root}cart`);
      } catch (error) {
        // A rendering error after a successful add must never encourage a duplicate add.
        if (added) window.location.assign(`${root}cart`);
        else status.textContent = error instanceof TypeError ? this.dataset.errorLabel : error.message;
      } finally {
        if (locked) window.updatingCart = false;
        form.dataset.busy = 'false';
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (select) select.disabled = false;
        label.textContent = originalLabel;
      }
    }
  });
}
